<form [formGroup]="organizationForm">
  <vnm-form-field [label]="label">
    <p-dropdown
      [options]="organizations$ | async | ownersToOptions"
      [placeholder]="placeholder | translate"
      [showClear]="showClear"
      formControlName="organizationGid"
      appendTo="body"
    ></p-dropdown>
  </vnm-form-field>
</form>
